import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeClockCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "time-clock-circle" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10.5,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 12,
			x2: 12,
			y2: 8.25,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 12,
			x2: 16.687,
			y2: 16.688,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		})
	]
});
export { SvgTimeClockCircle as ReactComponent };
